<template>
    <answers ref="answers"
             code_question_group="GQ09"
             danger_code="MCAL26"
    />
</template>

<script>
import answers from '../../../components/answers.vue';

export default {
    name: 'index',
    components: {
        answers
    }
};
</script>
